<template>
  <div class="app-body">
    <div style="font-size: 22px;color: #409EFF;cursor: pointer" @click="$router.push('/erp-store-log-manager')" >该功能已迁移至库存管理-库存记录,点击前往</div>
<!--    <StoreLogTable source-type="purchase" query-type="receiver" :hide-columns="['boxReceiptCode']" :default-query-params="{reason:'采购入库'}" :hide-query="['fuzzyOrderCode']"></StoreLogTable>-->
  </div>
</template>

<script>
/**
 * 收货记录列表
 */
import StoreLogTable from '@/views/modules/erp/common/store-log-table.vue'

export default {
  name: 'receive-manager',
  components: { StoreLogTable },
  data () {
    return {
    }
  },
  activated () {

  },
  watch: {

  },
  methods: {
  }
}
</script>

<style scoped>

</style>
